import { useRef, useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';

import * as CampaignQualificationAPI from '../../api/CampaignQualificationAPI';
import * as CampaignAction from '../../redux/actions/Campaign';
import * as UI from 'Shared/UI';

export const useToggleDeveloperQualification = ({ campaignIdentifier }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState({});

  const hideOverlayDebounce = useRef(
    debounce(async () => {
      UI.hideWorkingOverlay();
    }, 200)
  );

  useEffect(() => {
    if (campaignIdentifier) {
      if (status.error) {
        UI.showPageNotice(status.error, 'error');
      }
      if (!status.loading) {
        dispatch(CampaignAction.fetchCampaign(campaignIdentifier));
        hideOverlayDebounce.current();
      }
    }
  }, [status]);

  const createQualification = async ({
    quotaIdentifier,
    pre_code_values,
    qualification_id,
    question_id,
  }) => {
    setStatus({ loading: true });
    try {
      await CampaignQualificationAPI.create({
        pre_code_values,
        qualifiable_identifier: quotaIdentifier,
        qualification_id,
        question_id,
      });
      setStatus({ loading: false });
    } catch (err) {
      const { message = 'Error processing the request.' } =
        (err.response && err.response.data) || {};
      setStatus({ error: message, loading: false });
    }
  };

  const updateQualification = async (cq) => {
    setStatus({ loading: true });
    try {
      const { identifier, pre_code_values } = cq;
      await (!pre_code_values.length
        ? CampaignQualificationAPI.destroy(identifier)
        : CampaignQualificationAPI.update(identifier, {
            ...cq,
            skip_feasibility: true,
          }));
      setStatus({ loading: false });
    } catch (err) {
      const { message = 'Error processing the request.' } =
        (err.response && err.response.data) || {};
      setStatus({ error: message, loading: false });
    }
  };
  return { createQualification, updateQualification };
};
